import Translations from '@helpers/translations'
import { ButtonLink } from '@components/ui/Button'
import styles from './emptyCart.module.scss'

const EmptyCart = () => (
  <>
    <h2 className={styles.cart__title}>
      {Translations.localise('pages.cart.empty-basket')}
    </h2>
    <div className={styles.cart__links}>
      <ButtonLink
        variant="secondary"
        href="/collections/trousers"
        fullWidth="always"
        classes={styles.cart__linkButton}
      >
        Shop Trousers
      </ButtonLink>
      <ButtonLink
        variant="secondary"
        href="/collections/denim"
        fullWidth="always"
        classes={styles.cart__linkButton}
      >
        Shop Denim
      </ButtonLink>
      <ButtonLink
        variant="secondary"
        href="/collections/tops"
        fullWidth="always"
        classes={styles.cart__linkButton}
      >
        Shop Tops
      </ButtonLink>
      <ButtonLink
        variant="secondary"
        href="/collections/shorts"
        fullWidth="always"
        classes={styles.cart__linkButton}
      >
        Shop Shorts
      </ButtonLink>
    </div>
  </>
)

export default EmptyCart
